<template>
  <v-card color="#f0f8f6" class="overflow-hidden rounded-xl">
    <div class="text-right ma-3">
      <v-btn icon @click="$emit('cancel')">
        <v-icon large>mdi-close</v-icon>
      </v-btn>
    </div>
    <v-row justify="center" align="center" class="pb-3">
      <v-col cols="16" class="text-center text-h4">
        <div>История новостей</div>
      </v-col>
    </v-row>
    <v-card-text>
      <v-container v-if="loading">
        <v-row justify="center">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-row>
      </v-container>
      <v-container v-else-if="newsList.length === 0">
        <v-row justify="center">
          <div class="text-center">Новостей пока нет</div>
        </v-row>
      </v-container>
      <v-list v-else>
        <v-list-item
          v-for="item in newsList"
          :key="item.id"
          @click="openNews(item)"
          class="mb-2"
          style="background-color: white; border-radius: 8px; cursor: pointer"
        >
          <v-list-item-content>
            <v-list-item-title class="text-h6 mb-2">
              {{ item.title }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ formatDate(item.createdAt || item.created_at) }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-icon>mdi-chevron-right</v-icon>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import { SERVER_URI } from "@/api/NSApi";
import NSApi from "@/api/NSApi";

export default {
  name: "NewsHistoryModal",
  data() {
    return {
      newsList: [],
      loading: true,
    };
  },
  methods: {
    getImageUrl(imagePath) {
      if (!imagePath) return "";
      if (imagePath.startsWith("http")) return imagePath;
      if (imagePath.startsWith("/api/uploads")) return imagePath;
      return SERVER_URI + imagePath;
    },
    formatDate(dateString) {
      if (!dateString) return "";
      try {
        const date = new Date(dateString);
        return date.toLocaleDateString("ru-RU", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
        });
      } catch (e) {
        return dateString;
      }
    },
    async loadNews() {
      this.loading = true;
      try {
        const newsData = await NSApi.instance.getNews();
        this.newsList = newsData
          .filter((item) => item.active)
          .sort((a, b) => {
            const dateA = new Date(a.createdAt || a.created_at || 0);
            const dateB = new Date(b.createdAt || b.created_at || 0);
            return dateB - dateA;
          });
      } catch (error) {
        console.error("Error loading news:", error);
      } finally {
        this.loading = false;
      }
    },
    openNews(news) {
      this.$emit("open-news", news);
    },
  },
  mounted() {
    this.loadNews();
  },
};
</script>

<style scoped></style>
